import { useContext } from 'react';
import { CreatePolicyStoreContext } from './contextStore';

export function useCreatePolicyStore() {
	const context = useContext(CreatePolicyStoreContext);
	if (!context) {
		throw new Error(
			'useCreatePolicyStore must be used within CreatePolicyStoreProvider'
		);
	}
	return context;
}
